import { useCallback, useEffect, useState } from "react";
import type { SectorEcosystemOverview } from "../../../../../../shared/sectorEcosystemOverview";
import { fetchSectorEcosystemOverview } from "../sectorEcosystem.service";

export function useSectorEcosystem(slug: string | undefined) {
  const [data, setData] = useState<SectorEcosystemOverview | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const load = useCallback(async () => {
    if (!slug?.trim()) {
      setData(null);
      setLoading(false);
      setError("Sector not found.");
      return;
    }
    setLoading(true);
    setError(null);
    try {
      const overview = await fetchSectorEcosystemOverview(slug);
      setData(overview);
    } catch {
      setData(null);
      setError("Unable to load sector ecosystem. Please try again.");
    } finally {
      setLoading(false);
    }
  }, [slug]);

  useEffect(() => {
    void load();
  }, [load]);

  return { data, loading, error, reload: load };
}
